import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"10px"} }

import { unref, ref, reactive, h } from 'vue';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { ElMessage, ElMessageBox } from 'element-plus';
import { formatTools } from '@/utils';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';
import PayPlanDialog from './payplanDialog.vue';
import { GetPayplanListApi } from '@/apis/contract/contract.draft.api';


export default /*#__PURE__*/_defineComponent({
  props: {
	amount: { type: Number, default: () => 0.0 },
	payment: { type: String, default: () => '' },
},
  setup(__props, { expose }) {

const $props = __props

const { t } = useLocales();

const { fAmount } = formatTools();
const { register, tableObject } = useGbTable();



const payPlanRef = ref<InstanceType<typeof PayPlanDialog>>();

const payPlans = ref<any[]>([]); // 付款计划
const state = reactive({
	load: false,
	editingIndex:'',
});

const tabColumns = reactive<any[]>([
	{ field: 'name', label: t('performs.table.planName', '计划名称'), columnWidth: '150' },
	{ field: 'pay_condition', label: t('performs.table.planCondition', '款项条件') },
	{ field: 'amount', label: t('bill.applyAmount', '申请金额'), columnWidth: '120', align: 'right' },
	{ field: 'scale', label: t('performs.table.planScale', '申请比例'), columnWidth: '80', align: 'right' },
	{ field: 'pay_date', label: t('performs.table.plannedPayDate', '计划付款日期'), columnWidth: '100', align: 'center' },
	{ field: 'remark', label: t('categorys.table.remark', '备注'), columnWidth: '200', align: 'left' },
	{ field: 'actions', label: t('contractList.table.action', '操作'), columnWidth: '150', align: 'center' },
]);

const actions = {
	addPayPlan: () => {
		if ($props.amount <= 0 || !$props.payment) {
			ElMessage.error(t('payplan.message.invalidContractAmount', '合同金额不能小于等于0.00或未选择付款方式'));
			return;
		}
		unref(payPlanRef)?.openDialog($props.amount, $props.payment, unref(payPlans));
	},

	/* 编辑 */
	editorPlan: (plan: any) => {
		const { $index, row } = plan
		state.editingIndex = $index
		unref(payPlanRef)?.editDialog($props.amount, $props.payment, unref(payPlans), row);
	},

	callBack: (plan: any, isEdit: boolean) => {
		if (isEdit)
		{
			plan.scale = plan.scale.toFixed(2);			
			payPlans.value[state.editingIndex] = plan
		}
		else
		{
			plan.scale = plan.scale.toFixed(2);
			unref(payPlans).push(plan);
		}
	},

	/* 删除付款计划 */
	deletePlan: (scope: any) => {
		const { $index, row } = scope;
		const msg = t('payplan.message.deleteConfirm', '是否删除付款计划：[${row.name}]？').replace('${row.name}', row.name);

		ElMessageBox.confirm(msg, t('buttons.preview', '提示'), { lockScroll: false, confirmButtonText: t('buttons.submit', '确定'), cancelButtonText: t('buttons.cancel', '取消'), type: 'warning' }).then(async () => {
			payPlans.value.splice($index, 1);
		});
	},
};

const methods = {
	validate: () => {
		const planlist = unref(payPlans) ?? [];
		const amtTotal = planlist.reduce((tol: number, plan: any) => (tol*100 + plan.amount*100)/100, 0);

		if (planlist.length <= 0) {
			return { isValid: false, msg: t('payplan.message.noPayPlanSet', '付款计划未设置') };
		}

		if (amtTotal != $props.amount) {
			return { isValid: false, msg: t('payplan.message.amountMismatch', '设置付款计划总金额与合同金额不一致') };
		}

		return { isValid: true, msg: '' };
	},

	getPlanList: () => {
		return unref(payPlans) || [];
	},
	setPlanList: async (contractdId: string) => {
		state.load = true;
		const { succeeded, errors, data } = await GetPayplanListApi(contractdId);
		state.load = false;

		if (!succeeded) {
			ElMessage.error(`${t('payplan.message.loadPayPlanListError', '读取付款计划列表数据出错，可能的原因是：')}${errors}`);
		} else {
			payPlans.value = data || [];
		}
	},
	clearPlan: () => {
		payPlans.value = [];
	},
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: actions.addPayPlan
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payplan.form.addPayPlan', '新增付款计划')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_unref(GbTables), {
      columns: _unref(tabColumns),
      data: payPlans.value,
      "show-paged": false,
      onRegister: _unref(register)
    }, {
      scale: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(row.scale) + " %", 1)
      ]),
      amount: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(_unref(fAmount)(row.amount)), 1)
      ]),
      actions: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          icon: "Edit",
          type: "primary",
          link: "",
          onClick: ($event: any) => (actions.editorPlan(scope))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('buttons.modify', '编辑')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_el_button, {
          icon: "Delete",
          type: "danger",
          link: "",
          onClick: ($event: any) => (actions.deletePlan(scope))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('buttons.delete', '删除')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "data", "onRegister"]),
    _createVNode(PayPlanDialog, {
      ref_key: "payPlanRef",
      ref: payPlanRef,
      onSavePlan: actions.callBack
    }, null, 8, ["onSavePlan"])
  ], 64))
}
}

})